import * as React from 'react';
import {Link} from "react-router";

export default function SubChapterCard({title, img, index, link, newWindow}) {
    return (
        <Link to={link} target={newWindow ? '_blank' : ''} className="SubChapterCard">
            <div className="card_body">
                <img src={img} className="card_image" alt=''/>
            </div>
            <div className="card_title">
                {
                    index &&
                    <div className="index">#{index} - </div>
                }
                {
                    title.includes('<br/>') ?
                        title.split('<br/>').map((row, index) => <React.Fragment key={index}>{row}<br/></React.Fragment>)
                        :
                        title
                }
            </div>
        </Link>
    );
}